import { BaseModel, Guid, RecursivePartial } from '@models/base';

export class TaskControlFlowData extends BaseModel {
    taskId?: Guid;         // task id
    duration?: number;     // длительность выполнения (в часах? секундах?)
    endDate?: Date;        // дата завершения задачи

    constructor(json?: RecursivePartial<TaskControlFlowData>) {
        super(json);
        this.parseTaskControlFlowData(json || {});
    }

    parse(json: RecursivePartial<TaskControlFlowData>): TaskControlFlowData {
        super.parse(json);
        this.parseTaskControlFlowData(json);
        return this;
    }

    private parseTaskControlFlowData(json: RecursivePartial<TaskControlFlowData>): void {
        TaskControlFlowData.assignFields(this, json, ['taskId', 'duration']);
        TaskControlFlowData.assignDates(this, json, ['endDate']);
    }

}
